import classNames from "classnames";
import React, { PropsWithChildren, ReactNode } from "react";

interface CardBodyProps extends PropsWithChildren {
  bodyRightContent?: ReactNode;
  extraBodyClasses?: string;
}

export const CardBody: React.FC<CardBodyProps> = ({
  bodyRightContent,
  children,
  extraBodyClasses,
}) => {
  const cardClasses = classNames("card__body", {
    "card__body--with-side-content": bodyRightContent,
    [`${extraBodyClasses}`]: extraBodyClasses,
  });

  return (
    <article className={cardClasses}>
      {children} {bodyRightContent && bodyRightContent}
    </article>
  );
};
